import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getImageUrlFromBytes } from '../../../shared/utils';

import { Filter } from '../../../shared/components/filter';
import { filterTypes } from '../../../shared/constants/filterType';

import { fieldNames } from '../index';

import * as actions from '../store/actions';
import { isEmpty, isNumber, isString } from 'lodash';

interface GeneratedSignatureProps {
  setBytesToSave: (bytes: ArrayBuffer | undefined) => void;
  getFormValues: () => { [key: string]: any };
}

const GeneratedSignature: React.FC<GeneratedSignatureProps> = ({ setBytesToSave, getFormValues }) => {
  const dispatch = useDispatch();

  const [signatureUrl, setSignatureUrl] = useState<string | undefined>();

  const signatureStyleLookup = useSelector((state: any) => state.signature.signatureStyleLookup);
  const signatureStyleLookupLoading = useSelector((state: any) => state.signature.signatureStyleLookupLoading);
  const generatedSignature = useSelector((state: any) => state.signature.generatedSignature);
  const originalSignatureBytes = useSelector((state: any) => state.signature.originalSignatureBytes);

  useEffect(() => {
    setBytes(generatedSignature);
  }, [generatedSignature]);

  useEffect(() => {
    setBytes(originalSignatureBytes);
  }, [originalSignatureBytes]);

  const setBytes = (bytes: ArrayBuffer | undefined) => {
    setBytesToSave(bytes);
    const imageUrl = getImageUrlFromBytes(bytes);
    setSignatureUrl(imageUrl);
  };

  const onSignatureChange = () => {
    if (signatureTextTimeout) {
      clearTimeout(signatureTextTimeout);
      signatureTextTimeout = null;
    }

    const formData = getFormValues();

    if (!formData || !isNumber(formData.style) || !(isString(formData.signatureText) && !isEmpty(formData.signatureText.trim()))) {
      return;
    }

    signatureTextTimeout = setTimeout(() => dispatch(actions.getGeneratedSignature(formData.style, formData.signatureText) as any), 500);
  };

  let signatureTextTimeout: NodeJS.Timeout | null = null;

  return (
    <>
      <Filter
        filterType={filterTypes.inputText}
        name={fieldNames.signatureText}
        label="Text"
        onChange={onSignatureChange}
      />

      <Filter
        filterType={filterTypes.dropdownWithServerData}
        name={fieldNames.style}
        label="Style"
        data={signatureStyleLookup}
        dataLoading={signatureStyleLookupLoading}
        dataSearchAction={(searchString: string | undefined) => actions.getSignatureStyleLookup(searchString)}
        maxTagCount={1}
        fetchImmediately={true}
        mode="single"
        onChange={onSignatureChange}
      />

      {signatureUrl ? <img src={signatureUrl} alt="No Data" /> : null}
    </>
  );
};

export default GeneratedSignature;
